document.addEventListener("DOMContentLoaded", function(event) {
    if ('NodeList' in window && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg) {
            thisArg = thisArg || window;
            for (var i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }


    var lazyImages = [].slice.call(
        document.querySelectorAll(".lazy > img")
    )

    if ("IntersectionObserver" in window) {

        var lazyImageObserver =
            new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                           var lazyImage = entry.target;
                             lazyImage.src = lazyImage.dataset.src;
                             lazyImage.previousElementSibling.srcset = lazyImage.dataset.srcset_mobile;
                             lazyImage.previousElementSibling.previousElementSibling.srcset = lazyImage.dataset.srcset_desktop;
                             lazyImage.classList.add('show');
                             lazyImage.classList.remove("lazy");
                             lazyImageObserver.unobserve(lazyImage);

                    }
                });
            });

        lazyImages.forEach(function(lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    }
    else {
        var lazyloadThrottleTimeout;
        lazyloadImages = document.querySelectorAll(".lazy  > img");

        function lazyload () {
            if(lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
            }

            lazyloadThrottleTimeout = setTimeout(function() {
                var scrollTop = window.pageYOffset;
                lazyloadImages.forEach(function(lazyImage) {
                    if(lazyImage.offsetTop < (window.innerHeight + scrollTop)) {
                         lazyImage.src = lazyImage.dataset.src;
                        lazyImage.previousElementSibling.srcset = lazyImage.dataset.srcset_mobile;
                        lazyImage.previousElementSibling.previousElementSibling.srcset = lazyImage.dataset.srcset_desktop;
                        lazyImage.classList.add('show');
                        lazyImage.classList.remove("lazy");
                     }
                });
                if(lazyImages.length == 0) {
                    document.removeEventListener("scroll", lazyload);
                    window.removeEventListener("resize", lazyload);
                    window.removeEventListener("orientationChange", lazyload);
                }
            }, 20);
        }
        lazyload();
        document.addEventListener("scroll", lazyload);
        window.addEventListener("resize", lazyload);
        window.addEventListener("orientationChange", lazyload);
    }


});


